import { IClosedFunnelQuestionUpdateInput, ICreateClosedFunnelInput, IGetClosedFunnelListInput } from 'types/operation';
import { Request } from '../request';

export const createClosedFunnel = (params: ICreateClosedFunnelInput) => Request.post({
    url: '/admin-server/funnel/create', params,
});

export const getClosedFunnelList = (params: IGetClosedFunnelListInput) => Request.post({
    url: '/admin-server/funnel/page', params,
});

export const getClosedFunnelLink = (id: number) => Request.get({
    url: `/admin-server/funnel/link/${id}`,
});

export const updateClisedFunnelStatus = (id: number, status: 'A' | 'D') => Request.put({
    url: `/admin-server/funnel/status/update/${id}/${status}`,
});

export const duplicateClosedFunnel = (id: number) => Request.post({
    url: `/admin-server/funnel/duplicate/${id}`,
});

export const getClosedFunnelDetail = (id: string) => Request.get({
    url: `/admin-server/funnel/detail/${id}`,
});

export const updateClosedFunnelBasicInfo = (id: number, params: ICreateClosedFunnelInput) => Request.post({
    url: `/admin-server/funnel/update/${id}`, params,
});

export const updateClosedFunnelQuestion = (id: number, params: IClosedFunnelQuestionUpdateInput) => Request.post({
    url: `/admin-server/funnel/question/update/${id}`, params,
});

export const updateClosedFunnelFilter = (id: number, filterValues: string) => Request.post({
    url: `/admin-server/funnel/filter/update/${id}`, params: { filterValues },
});

// 新增批量更新filter接口
export const updateClosedFunnelFilterBatch = (data: Array<{ id: number; filterValues: string }>) => Request.post({
    url: '/admin-server/funnel/filter/update/batch',
    params: data,
});
